define("appkit/adapters/post", 
  ["appkit/adapters/application","exports"],
  function(__dependency1__, __exports__) {
    "use strict";
    var ApplicationAdapter = __dependency1__["default"];

    var ajax = ic.ajax;

    __exports__["default"] = ApplicationAdapter.extend({
      find: function(store, type, id) {
        return ajax("/posts/" + id).then(function(json) {
          // normalize JSON into "Ember Data Form"
          return json;
        });
      }
    });
  });